/* Reviews Slider JS */
document.addEventListener("DOMContentLoaded", function() {
    const slider = document.querySelector(".reviewSwiper");
    if (slider) {
        new Swiper(".reviewSwiper", {
            slidesPerView: 3,
            spaceBetween: 12,
            loop: false,
            speed: 700,
            navigation: {
                nextEl: ".swiper-button-next svg",
                prevEl: ".swiper-button-prev svg",
            },
           // pagination: {
               // el: ".swiper-pagination",
               /// clickable: true,
           // },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 12
                },
                600: {
                    slidesPerView: 2,
                    spaceBetween: 12
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 12
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 12
                }
            }
        });
    }
    /* Category Filter */
    const tabs = document.querySelectorAll(".tab-btn");
    const cards = document.querySelectorAll(".review-card");
    tabs.forEach(tab => {
        tab.addEventListener("click", function() {
            tabs.forEach(btn => {
                btn.classList.remove("active");
            });
            this.classList.add("active");
            let filter = this.dataset.filter;
            cards.forEach(card => {
                let category = card.dataset.category;
                if (filter === "all" || category === filter) {
                    card.style.display = "block";
                    setTimeout(() => {
                        card.style.opacity = "1";
                        card.style.transform = "scale(1)";
                    }, 50);
                } else {
                    card.style.opacity = "0";
                    card.style.transform = "scale(.9)";
                    setTimeout(() => {
                        card.style.display = "none";
                    }, 300);
                }
            });
        });
    });
});